import LegalLayout from "../components/LegalLayout";

export default function ResponsibleGambling() {
  return (
    <LegalLayout
      title="Responsible Gambling"
      overline="HELP · SUPPORT"
      path="/responsible-gambling"
      description="Know the signs, stay in control, and get help if gambling becomes a problem. Resources, hotlines, and self-exclusion tools."
    >
      <p className="text-lg">
        If betting stops being fun, it has stopped being a game. The Martingale system is
        particularly risky because chasing losses is baked into its design. Please read
        this page carefully.
      </p>

      <div className="border border-amber-500/40 bg-amber-500/5 p-6 mt-6">
        <div className="overline amber-text mb-2">IF YOU OR SOMEONE YOU KNOW NEEDS HELP</div>
        <div className="font-display text-3xl amber-text">1-800-GAMBLER</div>
        <p className="text-sm text-zinc-300 mt-2">
          24/7 confidential help across the U.S. · Text &ldquo;HELPLINE&rdquo; to 800-327-5050
        </p>
      </div>

      <h2 className="font-display text-2xl text-white mt-10 mb-3">Know the warning signs</h2>
      <ul className="list-disc list-inside space-y-2">
        <li>Betting more than you planned or more than you can afford to lose.</li>
        <li>Chasing losses by increasing stakes (this is how Martingale busts).</li>
        <li>Hiding bets, borrowing money, or missing work/school.</li>
        <li>Feeling anxious when you can't bet.</li>
        <li>Lying to family about wins and losses.</li>
      </ul>

      <h2 className="font-display text-2xl text-white mt-10 mb-3">Simple guardrails we recommend</h2>
      <ul className="list-disc list-inside space-y-2">
        <li>Set a weekly budget you can lose without impacting bills.</li>
        <li>Never run more than 4 Martingale steps in a sequence.</li>
        <li>Always reset progression on a win — the math only works that way.</li>
        <li>No drinking and betting.</li>
        <li>Take a 24-hour break after any 3+ loss streak.</li>
      </ul>

      <h2 className="font-display text-2xl text-white mt-10 mb-3">Self-exclusion & deposit limits</h2>
      <p>
        Every licensed U.S. sportsbook (DraftKings, FanDuel, BetMGM, Caesars, etc.) offers
        deposit limits, cool-off periods, and self-exclusion. Use them. Each state's
        regulator also maintains a permanent self-exclusion list:
      </p>
      <ul className="list-disc list-inside space-y-2">
        <li><a className="neon-text underline" href="https://www.ncpgambling.org/help-treatment/help-by-state/" target="_blank" rel="noopener noreferrer">NCPG — help by state</a></li>
        <li><a className="neon-text underline" href="https://www.gamblersanonymous.org/" target="_blank" rel="noopener noreferrer">Gamblers Anonymous</a></li>
        <li><a className="neon-text underline" href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer">BeGambleAware (UK / intl.)</a></li>
      </ul>

      <h2 className="font-display text-2xl text-white mt-10 mb-3">Close your Martingale Playbook account</h2>
      <p>
        If this product is not helping you, you can cancel Pro access instantly from the
        Billing page and email us via the <a href="/contact" className="neon-text underline">contact page</a>{" "}
        to delete your account entirely.
      </p>
    </LegalLayout>
  );
}
